export type Resolution = "delivered" | "rejected"

type PendingEntry = {
  promise: Promise<Resolution>
  resolve: (value: Resolution) => void
  roomJid: string
  createdAt: number
}

class PendingMessageRegistry {
  private pending = new Map<string, PendingEntry>()

  register(messageId: string, roomJid: string): Promise<Resolution> {
    const existing = this.pending.get(messageId)
    if (existing) return existing.promise

    let resolve!: PendingEntry["resolve"]
    const promise = new Promise<Resolution>((res) => {
      resolve = res
    })
    this.pending.set(messageId, {
      promise,
      resolve,
      roomJid,
      createdAt: Date.now(),
    })
    return promise
  }

  resolve(messageId: string, result: Resolution): void {
    const entry = this.pending.get(messageId)
    if (entry) {
      entry.resolve(result)
      this.pending.delete(messageId)
    }
  }

  delete(messageId: string): void {
    this.pending.delete(messageId)
  }
}

export default PendingMessageRegistry
